import { utils, writeFileXLSX } from "xlsx";

function appendSheet(workbook, sheetName, rows) {
  if (!rows?.length) {
    return;
  }

  const worksheet = utils.aoa_to_sheet(rows);
  utils.book_append_sheet(workbook, worksheet, sheetName);
}

function buildResumoSheet(summaryData) {
  if (!summaryData) {
    return [];
  }

  const rows = [
    ["Indicador", "Valor", "Tendência"],
    [
      "Quantidade de Acessos",
      summaryData.QuantidadeAcesso ?? 0,
      summaryData.TendenciaAcessos ?? "",
    ],
    [
      "Usuários Ativos",
      summaryData.QuantidadeUsuarioAtivo ?? 0,
      summaryData.TendenciaUsuarios ?? "",
    ],
    [],
    ["Detalhes por Perfil - Acessos"],
    ["Perfil", "Quantidade"],
  ];

  (summaryData.DetalhesPerfilAcessos ?? []).forEach((item) => {
    rows.push([item.Perfil ?? "", item.Quantidade ?? 0]);
  });

  rows.push([]);
  rows.push(["Detalhes por Perfil - Usuários Ativos"]);
  rows.push(["Perfil", "Quantidade"]);

  (summaryData.DetalhesPerfilUsuarios ?? []).forEach((item) => {
    rows.push([item.Perfil ?? "", item.Quantidade ?? 0]);
  });

  return rows;
}

function buildIndicadoresSheet(periodIndicators) {
  if (!periodIndicators?.length) {
    return [];
  }

  const rows = [[
    "Indicador",
    "Valor",
    "Tipo Detalhe",
    "Descrição",
    "Quantidade",
  ]];

  periodIndicators.forEach((item) => {
    const sections = [
      { tipo: "Perfil", items: item.detalhes ?? [], label: (det) => det.perfil, qtd: (det) => det.qtd },
      { tipo: "Período", items: item.detalhesPorPeriodo ?? [], label: (det) => det.periodo, qtd: (det) => det.qtd },
      { tipo: "Tela", items: item.detalhesPorTela ?? [], label: (det) => det.tela, qtd: (det) => det.qtd },
    ];

    let isFirstRow = true;

    sections.forEach((section) => {
      if (!section.items.length) {
        return;
      }

      section.items.forEach((detalhe) => {
        rows.push([
          isFirstRow ? item.nome ?? "" : "",
          isFirstRow ? item.valor ?? 0 : "",
          section.tipo,
          section.label(detalhe) ?? "",
          section.qtd(detalhe) ?? 0,
        ]);
        isFirstRow = false;
      });
    });

    if (isFirstRow) {
      rows.push([item.nome ?? "", item.valor ?? 0, "", "", ""]);
    }
  });

  return rows;
}

function buildTopUsersSheet(topUsers, topUsersDetails = []) {
  if (!topUsers?.length) {
    return [];
  }

  const detailsByUser = new Map(
    topUsersDetails.map((item) => [item.usuario, item]),
  );

  const rows = [[
    "Usuário",
    "Quantidade de Acessos",
    "Funcionalidade Mais Utilizada",
    "Quantidade na Funcionalidade",
  ]];

  topUsers.forEach((item) => {
    const usuario = item.Usuario ?? "";
    const funcionalidades = detailsByUser.get(usuario)?.funcionalidades ?? [];

    if (!funcionalidades.length) {
      rows.push([usuario, item.QuantidadeAcesso ?? 0, "", ""]);
      return;
    }

    funcionalidades.forEach((funcionalidade, index) => {
      rows.push([
        index === 0 ? usuario : "",
        index === 0 ? item.QuantidadeAcesso ?? 0 : "",
        funcionalidade.nome ?? "",
        funcionalidade.quantidade ?? 0,
      ]);
    });
  });

  return rows;
}

function buildTopFeaturesSheet(topFeatures, topFeaturesDetails = []) {
  if (!topFeatures?.length) {
    return [];
  }

  const detailsByFeature = new Map(
    topFeaturesDetails.map((item) => [item.funcionalidade, item]),
  );

  const rows = [[
    "Funcionalidade",
    "Quantidade de Acessos",
    "Usuário Mais Ativo",
    "Quantidade do Usuário",
  ]];

  topFeatures.forEach((item) => {
    const funcionalidade = item.Funcionalidade ?? "";
    const detail = detailsByFeature.get(funcionalidade);

    rows.push([
      funcionalidade,
      item.QuantidadeAcesso ?? 0,
      detail?.usuarioMaisAtivo ?? "",
      detail?.quantidadeUsuarioMaisAtivo ?? 0,
    ]);
  });

  return rows;
}

function buildMonthlyHistorySheet(monthlyHistory) {
  const months = monthlyHistory?.Meses ?? [];
  const indicadores = monthlyHistory?.Indicadores ?? [];

  if (!months.length || !indicadores.length) {
    return [];
  }

  const rows = [["Indicador", ...months]];

  indicadores.forEach((indicador) => {
    rows.push([
      indicador.Indicador ?? "",
      ...months.map((mes) => indicador.ValoresPorMes?.[mes] ?? 0),
    ]);
  });

  return rows;
}

export default function exportDashboardToXlsx({
  startDate,
  endDate,
  summaryData,
  periodIndicators,
  topUsers,
  topFeatures,
  topUsersDetails,
  topFeaturesDetails,
  monthlyHistory,
}) {
  const hasData =
    summaryData ||
    periodIndicators?.length ||
    topUsers?.length ||
    topFeatures?.length ||
    topUsersDetails?.length ||
    topFeaturesDetails?.length ||
    monthlyHistory?.Indicadores?.length;

  if (!hasData) {
    throw new Error("Não há dados para exportar. Aplique o filtro e aguarde o carregamento.");
  }

  const workbook = utils.book_new();

  appendSheet(workbook, "Resumo", buildResumoSheet(summaryData));
  appendSheet(workbook, "Indicadores", buildIndicadoresSheet(periodIndicators));
  appendSheet(workbook, "Top Usuarios", buildTopUsersSheet(topUsers, topUsersDetails));
  appendSheet(
    workbook,
    "Top Funcionalidades",
    buildTopFeaturesSheet(topFeatures, topFeaturesDetails),
  );
  appendSheet(
    workbook,
    "Historico Mensal",
    buildMonthlyHistorySheet(monthlyHistory),
  );

  const periodSuffix =
    startDate && endDate ? `_${startDate}_${endDate}` : "";

  writeFileXLSX(
    workbook,
    `indicadores-acesso${periodSuffix}.xlsx`,
  );
}
